import { action, computed, makeObservable, observable } from "mobx";
import { Fields } from "./Fields";
import validateOrganizationAdminInvite from "../../logic/ValidationChecks/OrganizationAdminInviteValidation";

export interface IOrganizationAdminInvite {
    email: string;
}

export class OrganizationAdminInvite extends Fields<IOrganizationAdminInvite, OrganizationAdminInvite> implements IOrganizationAdminInvite {
    @observable email: string;

    constructor(invite?: IOrganizationAdminInvite) {
        super();
        makeObservable(this);

        this.email = invite?.email || "";
    }

    @action setEmail(email: string) {
        this.email = email;
    }

    @computed get validationErrors() {
        return validateOrganizationAdminInvite(this);
    }
}